import { Viewer, Worker } from '@react-pdf-viewer/core';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';
import * as React from 'react';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';

interface ThumbnailExampleProps {
    fileUrl: string;
}

const ThumbnailRender: React.FC<ThumbnailExampleProps> = ({ fileUrl }) => {
    const thumbnailPluginInstance = thumbnailPlugin({
        thumbnailWidth: 150
    });
    const { Thumbnails } = thumbnailPluginInstance;

    return (
        <div
            className="rpv-core__viewer"
            style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                height: '100%',
                width: '100%',
                minHeight: '200px',
                overflow: 'auto',
                background: '#f8f9fa'
            }}
        >
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer
                    fileUrl={fileUrl}
                    plugins={[thumbnailPluginInstance]}
                />
            </Worker>
        </div>
    );
};

export default ThumbnailRender;
